import apiClient from '../../../api/client';
import { API_PATHS } from '../../../api/paths';
import type { CancelBookingResponse } from '../../../types/client';
import type { CancellationReason } from '../../../types/client';

export interface CancelRequestPayload {
  reason: CancellationReason;
}

/**
 * POST /v1/client/bookings/{uuid}/cancel
 * Auth: Bearer token — axiosClient interceptor avtomatik qo'shadi.
 */
export const cancelRequestApi = {
  requestCancel: async (
    bookingUuid: string,
    payload: CancelRequestPayload,
  ): Promise<CancelBookingResponse> => {
    const res = await apiClient.post<{ data: CancelBookingResponse }>(
      API_PATHS.clientBookingCancel(bookingUuid),
      { reason: payload.reason },
    );
    return res.data.data;
  },
};
